import React, { ComponentPropsWithRef, ReactNode } from "react";

/**
 * Table primitives. Thin wrappers rather than a data-grid: the pages already
 * own their sorting/filtering logic, they only needed the Bootstrap classes
 * replaced.
 */
export function Table({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className="panel overflow-x-auto">
      <table className={`w-full text-sm ${className}`}>{children}</table>
    </div>
  );
}

export function Th({
  children,
  className = "",
  ...props
}: ComponentPropsWithRef<"th">) {
  return (
    <th
      className={`border-hairline/70 border-b px-4 py-3 text-left text-xs font-medium tracking-wide text-zinc-500 uppercase whitespace-nowrap ${className}`}
      {...props}
    >
      {children}
    </th>
  );
}

export function Td({
  children,
  className = "",
  ...props
}: ComponentPropsWithRef<"td">) {
  return (
    <td
      className={`border-hairline/50 border-b px-4 py-3 text-zinc-700 ${className}`}
      {...props}
    >
      {children}
    </td>
  );
}

export function Tr({
  children,
  className = "",
  ...props
}: ComponentPropsWithRef<"tr">) {
  return (
    <tr
      className={`hover:bg-elevated/60 transition-colors ${className}`}
      {...props}
    >
      {children}
    </tr>
  );
}

/** Full-width empty/loading state that spans the table. */
export function TableEmpty({
  colSpan,
  children,
}: {
  colSpan: number;
  children: ReactNode;
}) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-10 text-center text-sm text-zinc-500">
        {children}
      </td>
    </tr>
  );
}
